import React, {PropTypes} from 'react';
import ReactDOM from 'react-dom';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import $ from 'jquery';
import Checkbox from '../stateless/Checkbox.react'
import FilterContainer from '../stateless/FilterContainer.react'
import ProjectContainer from '../stateless/ProjectContainer.react'
import Project from '../stateless/Project.react'
import CompanyContainer from '../stateless/CompanyContainer.react'
import Company from '../stateless/Company.react'
import RowWithLabel from '../stateless/RowWithLabel.react'
import SearchField from '../stateless/SearchField.react'
import BlueCheckbox from './BlueCheckbox.react'
import Slider from './Slider.react'

import {__} from '../../../server/lib/i18n-2/browserHelper'

export default class FilterApp extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
    this.state = {
      ...this.getInitialOrResetState(),
      foundEntities: [],
      closed: true,
    };

    // console.log('constructor state', this.state);
  }

  getInitialOrResetState() {
    const state = {
      filters: {},
      minMax: {},
      search: '',
      initial: true,
      showAll: false,
    }
    Object.keys(this.props.filters).forEach(f => {
      state.filters[f] = []
    })
    this.props.minMax.forEach(f => {
      state.minMax[f] = {min: false, max: false}
    })
    return state
  }

  getResetState() {
    const state = this.getInitialOrResetState()
    state.showAll = true
    return state
  }

  fetchData() {
    // console.log('start fetching data', this.state);
    $.ajax({
      url: '/api/filter',
      data: {data: this.serializeToParam(), model: this.props.model},
      success: (data, status) => {
        if (status != 'success') {
          console.log('ERROR', status, data);
          return
        }
        this.setState({foundEntities: data.foundEntities})
        console.log(this.state, 'this.state', data.foundEntities);
        $('#reactPopupsHtml').html(data.popupsHtml)
        window.bindPopupOpeners()
      }
    });
  }

  onFilterChange() {
    this.setState({initial: false})
    if (this.timeout)
      clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.fetchData()
      // window.location.hash = '#' + this.serializeToParam()
      // console.log("hash", window.location.hash)
    }, 1000);

  }

  serializeToParam () {
    return JSON.stringify({filters: this.state.filters, minMax: this.state.minMax, search: this.state.search, showAll: this.state.showAll})
  }

  componentDidMount() {
    const data = window.location.hash && window.location.hash.substr(1)
    this.setState(this.getInitialOrResetState(), this.fetchData)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  handleCheckboxChange(propName, id) {
    this.setState(oldState => {
      const {filters} = oldState
      // console.log('!!',filters, propName);
      const index = filters[propName].indexOf(id)
      // console.log(index);
      if (index === -1) {
        return {filters: {...filters, [propName]: [...filters[propName], id] }}
      } else {
        return {filters: {...filters, [propName]: filters[propName].filter( i => i != id)}}
      }
    })
    this.onFilterChange()
  }

  handleMinMaxChange(field, value) {
    this.setState(oldState => ({minMax: {...oldState.minMax, [field]: value}}), this.onFilterChange)
  }

  handleSearchChange(value) {
    this.setState({search: value})
    this.onFilterChange()
  }

  handleClose() {
    this.setState(oldState => ({closed: !oldState.closed}))
  }

  handleResetFilter() {
    // console.log("resetting" )
    this.setState(this.getResetState(), this.fetchData)
  }

  render() {
    const {filters, model, isUserLoggedIn, lang} = this.props
    const {closed} = this.state
    const searchField = <SearchField handleChange={(e) => this.handleSearchChange(e)}/>
    // TODO - split render according to entityName or sthing...

    const renderedFilters = Object.keys(filters).map(f => (
        <RowWithLabel alignToLeft={true} label={filters[f].label} key={f}>
          {filters[f].items.map((r, key) => {
            if (filters[f].blue) {
              return (<BlueCheckbox
                key={key} name={r.name} hint={r.hint}
                handleChange={() => this.handleCheckboxChange(f, r._id)}/>)
            } else {
              return (<Checkbox
                key={key} name={r.name} hint={r.hint}
                handleChange={() => this.handleCheckboxChange(f, r._id)}
                checked={this.state.filters[f].indexOf(r._id) !== -1}
                />)
            }
          })}
        </RowWithLabel>)
    )

    const renderedCompanySliders = (
      <div>
        <RowWithLabel alignToLeft={true} label={__('podle tržeb')} >
          <Slider positiveInfinity={true} negativeInfinity={false} maxValue={250000000} handleChange={(val) => this.handleMinMaxChange('sales', val)} />
        </RowWithLabel>
        <RowWithLabel alignToLeft={true} label={__('podle EBITDA')} >
          <Slider positiveInfinity={true} negativeInfinity={true} maxValue={250000000} handleChange={(val) => this.handleMinMaxChange('EBITDA', val)} />
        </RowWithLabel>
      </div>
    )

    const renderedProjectSliders = (
      <RowWithLabel alignToLeft={true} label={__('podle výše investice')} >
        <Slider positiveInfinity={true} negativeInfinity={false} maxValue={15000000} handleChange={(val) => this.handleMinMaxChange('investment', val)} />
      </RowWithLabel>
    )

    const renderedCompanyContainer = (
      <CompanyContainer showAllButton={!this.state.initial} showFinishedResults={this.state.initial} handleAllButtonClick={() => this.handleResetFilter()}>
        {this.state.foundEntities.map((entity, key) => (
          <Company lang={lang} key={key} {...entity} />
        ))}
      </CompanyContainer>
    )

    const renderedProjectContainer = (
      <ProjectContainer showAllButton={!this.state.initial} showFinishedResults={this.state.initial} handleAllButtonClick={() => this.handleResetFilter()}>
        {this.state.foundEntities.map((entity, key) => (
          <Project isUserLoggedIn={isUserLoggedIn} lang={lang} key={key} {...entity} dataLayer={this.props.dataLayer}/>
        ))}
      </ProjectContainer>
    )

      return (
        <div>
          <FilterContainer
            closed={closed}
            handleClose={() => {this.handleClose()}}
            searchField={searchField}
          >
            {model === 'Company' && renderedCompanySliders || renderedProjectSliders}
            {renderedFilters}
          </FilterContainer>
            {model === 'Company' && renderedCompanyContainer || renderedProjectContainer}
        </div>
      );
    }
}

FilterApp.propTypes = {
  api: React.PropTypes.string,
  model: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/browser/components/smart/FilterApp.react.js